import React, { useCallback, useEffect, useState } from 'react';
import { Box } from 'native-base';
import {
    useSpringBigStore,
    useLogOut,
    AuthPayload,
    useCheckAuth,
    useAppSettings,
} from '@springbig/shared';
import BottomNavigation from './BottomNavigation';
import TopNavigation from './TopNavigation';
import { useAppNavigate } from '~/pages';
import SideMenuScreen from '~/pages/menu/Menu';
import WalletTerms from '~/shared/WalletTerms';
import { useGeneralStyles } from '~/shared/styles';
import Loading from './Loading';
import PopUpContainer from '~/shared/SubsPopUps/PopUpContainer';
import GiftCardNotificationBanner from '~/shared/GiftCardNotificationBanner';
// import GiftCardBalanceAddNotification from './GiftCardBalanceAddNotification';

const Layout = ({ children }: { children: React.ReactNode }) => {

    const { wallet_terms } = useAppSettings();
    const {
        member,
        walletId,
        cleanState,
        mobileSubscriberId,
        setWalletId,
        merchant ,
        setNextStep,
        setBirthdays,
        stashboardTarget,
        setBirthdayInput,
    } = useSpringBigStore();
    const { location, navigate, params } = useAppNavigate();
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [showPopUps, setShowPopUps] = useState(true);
    const [isWalletTermsPopUpOpen, setWalletTermsPopUp] = useState(false);
    const isAuth = location.pathname.includes('auth');
    const { mutate: logoutAuth } = useLogOut({});
    const { mutate: checkAuth, isLoading, isError, isSuccess } = useCheckAuth();
    const { merchantOrg } = useAppSettings();

    useEffect(() => {

        setWalletTermsPopUp(!member?.wallet_terms && !!wallet_terms);
    }, [member]);

    const [viewportHeight, setViewportHeight] = useState<number>(window.innerHeight);

    useEffect(() => {

        const handleResize = () => {

            const height = window.innerHeight;
            setViewportHeight(height);
        };

        window.addEventListener('resize', handleResize);

        return () => {

            window.removeEventListener('resize', handleResize);
        };
    }, []);


    useEffect(() => {
    //THIS IS FOR MAC and IOS
        if (merchant?.display) {
            const existingFavicons = document.querySelectorAll('link[rel*=\'icon\']');
            existingFavicons.forEach(favicon => favicon.parentNode.removeChild(favicon));

            const createFaviconLink = (rel, href) => {

                const link = document.createElement('link');
                link.rel = rel;
                link.href = href;
                document.head.appendChild(link);
            };

            createFaviconLink('icon', merchant?.display);
            createFaviconLink('shortcut icon', merchant?.display);
            createFaviconLink('apple-touch-icon', merchant?.display);
        }
    }, [merchant?.display]);

    useEffect(() => {

        if (isSuccess && !isLoading) {

            const updateIcon = (rel, sizes, href) => {

                let link = document.querySelector(`link[rel='${rel}'][sizes='${sizes}']`);
                if (!link) {
                    link = document.createElement('link');
                    link.rel = rel;
                    link.sizes = sizes;
                    document.getElementsByTagName('head')[0].appendChild(link);
                }

                link.href = href;
            };

            if (merchant && merchant.display) {
                updateIcon('icon', '192x192', merchant.display);
                updateIcon('icon', '512x512', merchant.display);
                updateIcon('apple-touch-icon', '180x180', merchant.display);
            }

            if (merchantOrg) {
                document.title = merchantOrg;
            }

            const manifestContent = {
                name: merchantOrg || 'Your App Name',
                short_name: merchantOrg,
                start_url: '.',
                display: 'standalone',
                background_color: '#ffffff',
                theme_color: '#000000',
                icons: [
                    {
                        'src': merchant && merchant.display || 'favicon.ico',
                        'sizes': '64x64 32x32 24x24 16x16',
                        'type': 'image/x-icon'
                    },
                    {
                        'src': merchant && merchant.display || 'logo192.png',
                        'type': 'image/png',
                        'sizes': '192x192'
                    },
                    {
                        'src': merchant && merchant.display || 'logo512.png',
                        'type': 'image/png',
                        'sizes': '512x512'
                    }
                ]
            };

            const stringManifest = JSON.stringify(manifestContent);
            const blob = new Blob([stringManifest], { type: 'application/json' });
            const manifestURL = URL.createObjectURL(blob);
            let manifestLink = document.querySelector('link[rel="manifest"]');
            if (!manifestLink) {
                manifestLink = document.createElement('link');
                manifestLink.rel = 'manifest';
                document.head.appendChild(manifestLink);
            }

            manifestLink.href = manifestURL;
        }
    }, [isSuccess, isLoading, merchant]);

    // useEffect(() => {
    //
    //     observer.once('api-error', (data) => {
    //
    //         if ((data.response.status === 401 || data.response.status === 403) && walletId) {
    //
    //             cleanState();
    //             logoutAuth();
    //             const _wallet_id = (data.error.data && (data.error.data as any).merchant_member_key && (data.error.data as any).merchant_member_key) || walletId;
    //             setWalletId(_wallet_id);
    //             navigate(`w/${_wallet_id}`, { state: { from: location.pathname, isUnAuthorised: true } });
    //         }
    //     });
    // }, [navigate, walletId, location, cleanState, logoutAuth, setWalletId]);

    const toggleMenu = () => {

        setIsMenuOpen(prev => !prev);
    };

    useEffect(() => {

        if (params.wallet_id && walletId && walletId !== params.wallet_id) {
            cleanState();
            logoutAuth();
            navigate(`w/${params.wallet_id}/`, { state: { from: location.pathname } });
        }
    }, [cleanState, logoutAuth, navigate, params.wallet_id, walletId, location]);

    const getAuthMember = useCallback(
        (id: string, reference: AuthPayload['reference']) => {

            checkAuth({
                stashboardOrMemberKey: id,
                reference,
                skip_tendlc: new URLSearchParams(location.search).get('skip10dlc') ? new URLSearchParams(location.search).get('skip10dlc') === 'true' : undefined
            }, {
                onSuccess: (response) => {

                    if (response && !member) {
                        setNextStep(response.step);
                        setBirthdays(response.data);
                        setBirthdayInput(response.ten_dlc_birthday_input);
                        if (response.wallet_id) {
                            setWalletId(response.wallet_id);
                        }

                        if (response.merchant_member_key) {
                            setWalletId(response.merchant_member_key);
                        }

                        if (response.step === 'birthday' || response.step === 'login') {
                            navigate(`w/${response.wallet_id || response.merchant_member_key}/tendlc`);
                        }
                    }

                },
                onError: (error: any) => {

                    if (error.status === 401) {
                        cleanState();
                        logoutAuth();
                        setWalletId(error.data.merchant_member_key || error.data.wallet_id);
                        navigate(`w/${error.data.merchant_member_key || error.data.wallet_id}`, { state: { from: location.pathname, isUnAuthorised: true } });
                    }
                }
            });

        },
        [checkAuth, setWalletId]
    );

    useEffect(() => {

        if (params && params.stashboard_key && params.stashboard_key !== stashboardTarget) {
            getAuthMember(params.stashboard_key, 'stashboard');
        }

        if (params && params.wallet_id && params.wallet_id !== walletId) {
            setWalletId(params.wallet_id);
            getAuthMember(params.wallet_id, 'member');
        }
    }, [params.wallet_id, params.stashboard_key]);

    useEffect(() => {

        if (walletId && walletId !== params.wallet_id && params.wallet_id !== undefined) {
            return () => {

                cleanState();
            };
        }

    }, [mobileSubscriberId, navigate, params, walletId, cleanState, member]);

    useEffect(() => {

        isAuth && setIsMenuOpen(false);
    }, [isAuth]);

    const gStyle = useGeneralStyles();

    const onHandleClosePopUp = () => {

        setShowPopUps(false);
    };

    return (
        <Box
            w={'clamp(320px, 100vw, 480px)'}
            h={viewportHeight}
            mx={'auto'}
            justifyContent={'space-between'}
            alignItems={'center'}
            bg={gStyle.screen_background}
        >
            { isLoading ?
                <Loading isLoading />
                :
                (!isError &&
                    <>
                        <TopNavigation isMenuOpen={isMenuOpen} toggleMenu={toggleMenu} />
                        { isWalletTermsPopUpOpen && member?.terms_and_conditions_link &&
                            <WalletTerms />
                        }
                        <Box w={'100%'} flex={1} display={'flex'} flexDirection={'row'} overflow={'hidden'}>
                            <div style={{ pointerEvents: isMenuOpen ? 'none' : 'all', height: '100%', width: '100%' }} >
                                <Box flex={1} overflowY={'auto'} h={'100%'} w={'100%'} opacity={isMenuOpen ? 0.3 : 1} overflow='auto'>
                                    { member && !!member.subscriptions_enabled && showPopUps &&
                                        <PopUpContainer onClose={onHandleClosePopUp} />
                                    }

                                    <GiftCardNotificationBanner />

                                    { children }

                                </Box>
                            </div>
                            <div style={{ height: '100%', width: 300, display: isMenuOpen ? 'flex' : 'none', position: 'absolute', right: 0 }}>
                                <SideMenuScreen toggleMenu={toggleMenu} />
                            </div>
                        </Box>
                        <BottomNavigation />
                    </>
                )
            }
        </Box>
    );
};

export default Layout;
